<div
  class="date-picker"
  [attr.data-size]="size"
  [attr.data-variant]="variant"
  [attr.data-disabled]="disabled"
  [attr.data-full-width]="fullWidth"
  [attr.data-required]="required"
  [attr.data-error]="error"
  [attr.data-open]="isCalendarOpen"
>
  <!-- Date Input using umss-date-picker-input -->
  <umss-date-picker-input
    [id]="computedId"
    [label]="label"
    [placeholder]="placeholder || 'Choose a date'"
    [value]="_selectedDate ? formattedDate : ''"
    [size]="size"
    [disabled]="disabled"
    [required]="required"
    [error]="error"
    [readonly]="true"
    [fullWidth]="fullWidth"
    inputType="text"
    (mousedown)="!disabled && toggleCalendar()"
    (focus)="!disabled && openCalendar()"
  >
  </umss-date-picker-input>

  <!-- Calendar Dropdown -->
  <div
    *ngIf="isCalendarOpen"
    class="date-picker-calendar"
    role="dialog"
    [attr.aria-label]="'Calendar for ' + (label || 'date selection')"
    [style.top]="calendarTop"
    [style.left]="calendarLeft"
  >
    <!-- Calendar Header using umss-date-picker-header -->
    <umss-date-picker-header
      [currentMonth]="currentMonth.getMonth()"
      [currentYear]="currentMonth.getFullYear()"
      [locale]="locale"
      layout="1Month"
      variant="Default"
      size="Regular"
      (previousMonth)="onPreviousMonth()"
      (nextMonth)="onNextMonth()"
    >
    </umss-date-picker-header>

    <!-- Calendar Grid -->
    <div class="calendar-grid">
      <!-- Weekday Headers -->
      <div class="calendar-weekdays">
        <div
          *ngFor="let weekday of weekdayNames"
          class="calendar-weekday"
          [attr.aria-label]="weekday"
        >
          {{ weekday }}
        </div>
      </div>

      <!-- Calendar Weeks -->
      <div class="calendar-weeks">
        <div
          *ngFor="let week of weeks; trackBy: trackWeek"
          class="calendar-week"
        >
          <button
            *ngFor="let day of week.days; trackBy: trackDay"
            type="button"
            class="calendar-day"
            [attr.data-current-month]="day.isCurrentMonth"
            [attr.data-today]="day.isToday"
            [attr.data-selected]="day.isSelected"
            [attr.data-weekend]="day.isWeekend"
            [attr.data-highlighted]="day.isHighlighted"
            [disabled]="day.isDisabled"
            [attr.aria-label]="
              day.date.toLocaleDateString(locale, {
                weekday: 'long',
                year: 'numeric',
                month: 'long',
                day: 'numeric'
              })
            "
            [attr.aria-selected]="day.isSelected"
            (click)="onDateSelect(day)"
          >
            {{ day.dayNumber }}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
